import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, switchMap } from "rxjs";
import { AppActions } from "@store/app.actions";
import { globalActions } from "@store/global/global.actions";
import { PlatformClient } from "@clients/api.client";
import { VersionProvider } from "@utilities/version.provider";

@Injectable()
export class GlobalEffects {
	public getVersion$ = createEffect(() => this.actions$.pipe(
		ofType(AppActions.started),
		switchMap(() => {
			return this.platformClient.getPlatformVersion$().pipe(
				map((response) => globalActions.updateVersion({version: response}))
			)
		})
	));

	public getUIVersion$ = createEffect(() => this.actions$.pipe(
		ofType(AppActions.started),
		switchMap(() => {
			return this.versionProvider.version$.pipe(
				map((response) => globalActions.updateUIVersion({uiVersion: response}))
			)
		})
	));

	constructor(
		private actions$: Actions,
		private platformClient: PlatformClient,
		private versionProvider: VersionProvider
	) {
	}
}
